var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromocionesIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 39.43 39.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5.8 5.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35,10l-8.49,8.5L6.77,17.4l8.49-8.5ZM9.68,20.28l1.09,1.09,6.31-6.29L16,14Zm16.76-9.19a1.16,1.16,0,0,0,.1,1.47h0a1.15,1.15,0,0,1,0,1.61L13.65,27.07a2.62,2.62,0,0,1-3.7,0L.76,17.88a2.64,2.64,0,0,1,0-3.7L13.66,1.29a1.12,1.12,0,0,1,1.61,0,1.19,1.19,0,0,0,.8.32,1.14,1.14,0,0,0,.67-.22,6.87,6.87,0,0,1,8.39.08L26.6,0h1.23V1l-1.59,1.6A7,7,0,0,1,26.44,11.09ZM25.15,3.64,23.39,5.39a2.86,2.86,0,1,1-1.17-1.06L24,2.56a5.36,5.36,0,0,0-6.37,0,2.69,2.69,0,0,1-1.6.53,2.57,2.57,0,0,1-1.58-.51L1.86,15.27a1.07,1.07,0,0,0,0,1.52L11,26a1.09,1.09,0,0,0,1.52,0L25.19,13.34a2.67,2.67,0,0,1,0-3.18A5.42,5.42,0,0,0,25.15,3.64ZM21.07,5.59a1.16,1.16,0,0,0-1.16,1.16h0a1.16,1.16,0,0,0,1.16,1.16h0a1.16,1.16,0,0,0,1.16-1.16h0A1.16,1.16,0,0,0,21.07,5.59Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "promociones_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35,10l-8.49,8.5L6.77,17.4l8.49-8.5ZM9.68,20.28l1.09,1.09,6.31-6.29L16,14Zm16.76-9.19a1.16,1.16,0,0,0,.1,1.47h0a1.15,1.15,0,0,1,0,1.61L13.65,27.07a2.62,2.62,0,0,1-3.7,0L.76,17.88a2.64,2.64,0,0,1,0-3.7L13.66,1.29a1.12,1.12,0,0,1,1.61,0,1.19,1.19,0,0,0,.8.32,1.14,1.14,0,0,0,.67-.22,6.87,6.87,0,0,1,8.39.08L26.6,0h1.23V1l-1.59,1.6A7,7,0,0,1,26.44,11.09ZM25.15,3.64,23.39,5.39a2.86,2.86,0,1,1-1.17-1.06L24,2.56a5.36,5.36,0,0,0-6.37,0,2.69,2.69,0,0,1-1.6.53,2.57,2.57,0,0,1-1.58-.51L1.86,15.27a1.07,1.07,0,0,0,0,1.52L11,26a1.09,1.09,0,0,0,1.52,0L25.19,13.34a2.67,2.67,0,0,1,0-3.18A5.42,5.42,0,0,0,25.15,3.64ZM21.07,5.59a1.16,1.16,0,0,0-1.16,1.16h0a1.16,1.16,0,0,0,1.16,1.16h0a1.16,1.16,0,0,0,1.16-1.16h0A1.16,1.16,0,0,0,21.07,5.59Z",
    transform: "translate(5.8 5.8)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_124",
    "data-name": "Trazado 124",
    d: "M-5.8-5.8H33.63V33.63H-5.8Z",
    transform: "translate(5.8 5.8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocionesIco);
export default __webpack_public_path__ + "static/media/promociones_ico.26d39384bee85516a9f41d7b8555b6a9.svg";
export { ForwardRef as ReactComponent };